/** 时间线计划步 / 出站条按钮：对齐 2026-08-08 状态机 A–E */

export type PlanDraftActions = {
  canDraftNow: boolean;
  canRedraft: boolean;
  canSendNow: boolean;
  canCancelSend: boolean;
  canReschedule: boolean;
  canReplay: boolean;
};

export function planDraftActions(plan: {
  preview?: boolean;
  needsAiDraft?: boolean;
  planStepId?: number;
  stepStatus?: string;
  hasPendingConfirmOutbound?: boolean;
  hasSentOutbound?: boolean;
  hasVoidedOrCancelledOutbound?: boolean;
  outboundStatus?: "pending_confirm" | "sent" | "failed" | "cancelled" | null;
}): PlanDraftActions {
  const none: PlanDraftActions = {
    canDraftNow: false,
    canRedraft: false,
    canSendNow: false,
    canCancelSend: false,
    canReschedule: false,
    canReplay: false,
  };
  if (plan.preview || plan.planStepId == null) return none;

  if (plan.hasPendingConfirmOutbound || plan.outboundStatus === "pending_confirm") {
    return { ...none, canCancelSend: true };
  }
  if (plan.hasSentOutbound || plan.outboundStatus === "sent") {
    return { ...none, canReplay: true };
  }
  if (
    plan.hasVoidedOrCancelledOutbound ||
    plan.outboundStatus === "cancelled" ||
    plan.outboundStatus === "failed"
  ) {
    return { ...none, canReschedule: true };
  }

  if (plan.needsAiDraft) {
    return { ...none, canDraftNow: true };
  }

  return { ...none, canRedraft: true, canSendNow: true };
}
